import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BtnGroupStyle } from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import { ClinicDetails } from "../../Apis/AuthApiServices";
import useFetch from "../../CustomHooks/useFetch";

export default function EPCSAlert({
  multiDea,
  message,
  handleShowIDMEPopupClick,
  handleHideSentPopupClick,
  getSummarySendToPharmacy,
  URL,
  fromClickFA,
}: any) {
  const [currentDateTime, setCurrentDateTime] = useState(
    moment().format("MM/DD/YYYY hh:mm:ss A")
  );
  const PrescriberDetailsState = useSelector((state: any) => {
    return { ...state.PrescriberDetailsSlice };
  }); //redux data
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  });
  //redux data
  const { AllPrescriberDetails } = PrescriberDetailsState;
  const {
    userName,
    primaryAndSecondaryDeas,
    mfaRouteActivated,
    // dea,
  } = AllPrescriberDetails;
  const Params = {
    doctorId:
      UserServiceState?.profileGroup > 6
        ? localStorage.getItem("SupervisorDoctorId")
        : localStorage.getItem("doctorId"),
    pageNumber: 0,
    pagination: "none",
  };

  const { data, loading, error }: any = useFetch(Params, ClinicDetails, []);

  const dea = data[0]?.items?.filter(
    (item: any) => item.personAddressId === sessionStorage.getItem("clinicId")
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDateTime(moment().format("MM/DD/YYYY hh:mm:ss A"));
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Doctor Name:
          </Typography>
        </Grid>
        <Grid item xs={12} md={9}>
          <Typography component={"div"} variant={"body2"}>
            {userName}
          </Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            DEA:
          </Typography>
        </Grid>
        <Grid item xs={12} md={9} textAlign="left">
          {/* <Typography component={"div"} variant={"body2"}>
            {dea ?? "Not Available"}
          </Typography> */}
          {multiDea ? (
            <Typography component={"div"} variant={"body2"}>
              {primaryAndSecondaryDeas?.join(", ") ?? "Not Available"}
            </Typography>
          ) : (
            <Typography component={"div"} variant={"body2"}>
              {loading
                ? "Loading..."
                : error
                ? "Something wrong..."
                : dea?.[0]?.deaNo ?? "Not Available"}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Date&Time:
          </Typography>
        </Grid>
        <Grid item xs={12} md={9} textAlign="left">
          <Typography component={"div"} variant={"body2"}>
            {currentDateTime}
          </Typography>
        </Grid>
        <Grid item xs={12} textAlign="left">
          <Typography component={"div"} variant={"body2"}>
            By completing the two-factor authentication protocol at this time,
            you are legally signing the prescription(s) and authorizing the
            transmission of the above information to the pharmacy for
            dispensing. The two-factor authentication protocol may only be
            completed by the practitioner whose name and DEA registration number
            appear above. <br />
            <br />
            {message
              ? "If you choose 'Cancel' option, Controlled substance prescriptions will be printed."
              : "If you choose 'Cancel' option, only Pop-up will closed."}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <BtnGroupStyle className="center">
            <YSButton
              children="Ok"
              variant="contained"
              type="button"
              onClick={() => {
                if (mfaRouteActivated === true || window.self !== window.top) {
                  handleHideSentPopupClick();
                  handleShowIDMEPopupClick();
                } else {
                  window.open(`${URL}`, "_self");
                }
              }}
              size="large"
              className=""
            />
            <YSButton
              color="secondary"
              children="Cancel"
              variant="outlined"
              type="button"
              onClick={() => {
                handleHideSentPopupClick();
                if (fromClickFA === "SAP") {
                  getSummarySendToPharmacy(false, true, "SS", "epcsCancel");
                } else {
                  getSummarySendToPharmacy(false, false, "STP", "epcsCancel");
                }
              }}
              size="large"
              className=""
            />
          </BtnGroupStyle>
        </Grid>
      </Grid>
    </>
  );
}
